import React from 'react';

const DetailSkeleton: React.FC = () => {
    return (
        <main className="bg-gradient-to-br from-pink-50 via-purple-50 to-pink-100 min-h-screen">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-6 pb-6">
                <div className="max-w-2xl mx-auto">
                    {/* 헤더 영역 */}
                    <div className="flex items-center gap-4 mb-6 animate-pulse">
                        <div className="w-6 h-6 bg-gray-300 rounded"></div>
                        <div className="h-8 bg-gray-300 rounded w-48"></div>
                    </div>

                    {/* 프로필 카드 스켈레톤 */}
                    <div className="flex justify-center mb-4">
                        <div className="relative bg-white/90 rounded-3xl shadow-lg border-4 border-pink-200 overflow-hidden inline-block w-full max-w-md animate-pulse">
                            <div className="w-full h-48 bg-gray-200"></div>
                            <div className="p-6 space-y-3">
                                <div className="h-5 bg-gray-200 rounded w-32 mx-auto"></div>
                                <div className="h-5 bg-gray-200 rounded w-24 mx-auto"></div>
                            </div>
                        </div>
                    </div>

                    {/* 컨텐츠 스켈레톤 */}
                    <div className="space-y-4">
                        {[1, 2, 3, 4, 5].map((i) => (
                            <div key={i} className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-md border border-gray-200 animate-pulse">
                                <div className="h-6 bg-gray-200 rounded w-32 mx-auto mb-4"></div>
                                <div className="space-y-2">
                                    <div className="h-4 bg-gray-200 rounded w-full"></div>
                                    <div className="h-4 bg-gray-200 rounded w-5/6 mx-auto"></div>
                                    <div className="h-4 bg-gray-200 rounded w-4/6 mx-auto"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </main>
    );
};

export default DetailSkeleton;

